import React from 'react'
import Modal from './Modal'
import Player from './Player'
import GameBox from './GameBox'

const Titlebar = ({
    socket,
    currUser,
    gamers,
    shoutsCount,
    mmNew,
    isInMMNewQueue,
    statusHistory,
    users,
    maxPlayersNum,
    questBox,
    handleKickStatus,
    handleOpenSeasonsModal,
    me,
    isWinter,
    handleOpenEventsModal,
    menuActive,
    handleOpenNewsModal,
    handleOpenUsersModal,
    userSuspended,
    showMPBtn,
    setShowMPBtn,
    generateCreatedAt,
    setCurrSingleUserName,
    currSingleUserName
}) => {

    const [status, setStatus] = React.useState(`Dobrodošao/la ${currUser}`)
    const [btnLabel, setBtnLabel] = React.useState('Multiplayer')
    const [MPtimer, setMPtimer] = React.useState(0)
    const [showModal, setShowModal] = React.useState(false)
    const [showMMModal, setShowMMModal] = React.useState(false)
    const [showMMNewModal, setShowMMNewModal] = React.useState(false)
    const [title, setTitle] = React.useState('')
    const [showRadio, setShowRadio] = React.useState(false)
    const [showPracticeModal, setShowPracticeModal] = React.useState(false)

    currUser = localStorage.getItem('userName')

    React.useEffect(() => {
        const handleSetQuest = titleToSet => {
            setTitle(titleToSet)
        }

        socket.on('setQuest', handleSetQuest)

        return () => {
            socket.off('setQuest', handleSetQuest)
        }

    }, [socket, title])

    React.useEffect(() => {
        const handleTimer = (mpCountdown) => {
            setMPtimer(mpCountdown)
        }
        socket.on('timer', handleTimer)

        return () => {
            socket.off('timer', handleTimer)
        }
    }, [socket, MPtimer])

    React.useEffect(() => {

        const handleResetTimer = () => {
            setMPtimer(0)
        }
        socket.on('resetTimer', handleResetTimer)

        return () => {
            socket.off('resetTimer', handleResetTimer)
        }
    }, [socket, MPtimer])

    React.useEffect(() => {
        const gamersNum = Object.keys(gamers).length
        if (gamersNum === 0) {
            setBtnLabel('Multiplayer')
            setMPtimer(0)
        } else if (gamers[currUser] !== undefined) {
            setBtnLabel('Leave')
        } else if (gamers[currUser] === undefined && gamersNum !== 0 && gamersNum < maxPlayersNum) {
            setBtnLabel('Join')
        } else if (gamers[currUser] === undefined && gamersNum === maxPlayersNum) {
            setShowMPBtn(false)
        }
    }, [gamers])

    React.useEffect(() => {

        const handleStatusUpdate = newStatus => {
            setStatus(newStatus)
        }
        socket.on('statusUpdate', handleStatusUpdate)

        return () => {
            socket.off('statusUpdate', handleStatusUpdate)
        }

    }, [socket, status])

    const handleGameBtnClick = () => {
        if (gamers[currUser] !== undefined) {
            socket.emit('leaveMP', currUser)
            return
        }
        socket.emit('game', currUser)
    }

    const handleCloseMMNewModal = () => {
        setShowMMNewModal(false)
    }

    const handleOpenMMNewModal = () => {
        setShowMMNewModal(true)
    }

    const handleCloseModal = () => {
        setShowModal(false)
    }

    const handleOpenModal = () => {
        setShowModal(true)
    }

    const handleMMBtnClick = () => {
        setShowMMModal(true)
    }

    const handleCloseMMModal = () => {
        setShowMMModal(false)
    }

    const handleShowRadio = () => {
        setShowRadio(!showRadio)
    }

    const handleOpenPracticeModal = () => {
        setShowPracticeModal(true)
    }

    const handleClosePracticeModal = () => {
        setShowPracticeModal(false)
    }

    const generateTitleBar = () => {
        return (
            <div>
                {
                    menuActive && <div className="main-header">
                        <div className="statusbar">

                            {status.length < 60
                                ?
                                <p>{status}</p>
                                :
                                <p className="text-carousel-titlebar">
                                    <span
                                        style={{ animation: 'marquee 15s linear infinite' }}>
                                        {status}
                                    </span>
                                </p>
                            }

                            <img onClick={handleOpenModal} className="margin-left-15 pointer" src="https://img.icons8.com/ios-filled/20/FFFFFF/clock--v3.png" />
                            <img onClick={handleOpenPracticeModal} className="margin-left-15 pointer" src="https://img.icons8.com/ios-filled/25/FFFFFF/keyboard.png" />
                            <img onClick={handleOpenSeasonsModal} className="margin-left-15 pointer" src="https://img.icons8.com/external-creatype-glyph-colourcreatype/25/FFFFFF/external-achievement-essential-ui-v4-creatype-glyph-colourcreatype.png" />
                            <img onClick={handleOpenEventsModal} className="margin-left-15 pointer" src="https://img.icons8.com/ios-filled/20/FFFFFF/star.png" />
                            <img onClick={handleOpenUsersModal} className="margin-left-15 pointer hidden m1300-show" src="https://img.icons8.com/ios-glyphs/25/FFFFFF/user-group-man-woman.png" />
                            <img onClick={handleOpenNewsModal} className="margin-left-15 pointer hidden m1200-show" src="https://img.icons8.com/ios-glyphs/25/FFFFFF/news.png" />
                            {/* <div className="relative">
                                {shoutsCount !== 0 ? <span className="shout-number">{shoutsCount}</span> : null}
                                <img onClick={handleMMBtnClick} className="botimgttlbr" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAABUUlEQVR4nO3Uz0oDMRDH8bl40r6BHtqLf87qSxYrvoIHERE9tIX6Gtp3EAUPtUeFr8TmILjZlmxmN9H5wLJLYJL9ZbIrYkxZgD3gFnj31x2wLwWGeOM3N7YrpWDViZAbKQWroxSykFIArzVBXqQUwHVNkCspBTAAnitCuLGBlAToA5c/QrjnvpQKT0qHBVEEHAEj4AlYkt7Sz30GHGoE2AIugE/a8wGcu7VThnigO7MkYXwnujZK8U20eZzqjtlBkyDuw87FsEmQOfl4bBJE4xcba9EkSFZEOcgYOAG2/X2iVINmkHGg7j5xjXqQ40DdaeKab6leukovMFcvcU1QqiCtdkQzyCTwUtPENepB8H8ct5s7/j5VqlEP0imxIJkR60hmxDqSGfmzHakSO1ns+DoSK3aB2PF1LAgbso403LCNWUe80MZk25G2yL8PYoxE+wJmA95jdYQihQAAAABJRU5ErkJggg==" />
                            </div> */}
                            <img onClick={handleMMBtnClick} className="botimgttlbr" src="https://img.icons8.com/glyph-neue/25/FFFFFF/bot.png" />

                            {showModal && <Modal
                                currUser={currUser}
                                handleCloseModal={handleCloseModal}
                                socket={socket}
                                title='Povijest statusa'
                                statusHistory={statusHistory}
                                type='statusHistory'
                                handleKickStatus={handleKickStatus}
                            />}
                            {showMMModal && <Modal
                                currUser={currUser}
                                handleCloseModal={handleCloseMMModal}
                                socket={socket}
                                title=''
                                type='matchmakingQueue'
                                users={users}
                                me={me}
                                userSuspended={userSuspended}
                            />}
                            {showMMNewModal && <Modal
                                mmNew={mmNew}
                                currUser={currUser}
                                handleCloseModal={handleCloseMMNewModal}
                                socket={socket}
                                title='1-1 matchmaking'
                                type={'MMNew'}
                                me={me}
                            />}
                            {showPracticeModal && <Modal
                                handleCloseModal={handleClosePracticeModal}
                                socket={socket}
                                title='Vježbaj tipkanje'
                                type={'practice'}
                                questBox={questBox}
                            />}
                            <div className={showModal || showMMModal || showPracticeModal || showMMNewModal ? 'overlay-app' : ''}></div>
                        </div>
                        <div className="btns-row margin-top-2">
                            <button onClick={handleOpenMMNewModal} className={`content-button ${isWinter && 'christmass-btn margin-top-5'}`}>Matchmaking</button>
                            {showMPBtn && !userSuspended && users.length !== 1 ? <button onClick={handleGameBtnClick} className={`content-button game-bg margin-left ${isWinter && 'christmass-btn margin-top-5'}`}>{`${btnLabel} ${MPtimer === 0 ? '' : MPtimer}`}</button> : null}
                        </div>
                    </div>
                }

                <div className="main-header main-header-alt">
                    {
                        menuActive && <div className="search-bar-alt" style={{
                            display: !showRadio ? 'none' : ''
                        }}>
                            <Player generateCreatedAt={generateCreatedAt} me={me} userSuspended={userSuspended} socket={socket} setCurrSingleUserName={setCurrSingleUserName} currSingleUserName={currSingleUserName} />
                        </div>
                    }

                    {
                        menuActive && <div className="statusbar statusbar-alt">
                            {status.length < 60
                                ?
                                <p className="margin-top-5 m780-hide">{status}</p>
                                :
                                <p className="margin-top-5 m780-hide text-carousel-titlebar">
                                    <span
                                        style={{ animation: 'marquee 15s linear infinite' }}>
                                        {status}
                                    </span>
                                </p>
                            }

                            <img onClick={handleOpenModal} className="titlebar-ico" src="https://img.icons8.com/ios-filled/20/FFFFFF/clock--v3.png" />
                            <img onClick={handleShowRadio} className="radijo-btn titlebar-ico" src="https://img.icons8.com/ios-filled/25/FFFFFF/radio.png" />
                            <img onClick={handleOpenPracticeModal} className="titlebar-ico" src="https://img.icons8.com/ios-filled/25/FFFFFF/keyboard.png" />
                            <img onClick={handleOpenSeasonsModal} className="titlebar-ico" src="https://img.icons8.com/external-creatype-glyph-colourcreatype/25/FFFFFF/external-achievement-essential-ui-v4-creatype-glyph-colourcreatype.png" />
                            <img onClick={handleOpenEventsModal} className="titlebar-ico" src="https://img.icons8.com/ios-filled/20/FFFFFF/star.png" />
                            <img onClick={handleOpenUsersModal} className="titlebar-ico hidden m1300-show" src="https://img.icons8.com/ios-glyphs/25/FFFFFF/user-group-man-woman.png" />
                            <img onClick={handleOpenNewsModal} className="titlebar-ico hidden m1200-show" src="https://img.icons8.com/ios-glyphs/25/FFFFFF/news.png" />
                            {/* <div className="relative shoutbox-ico-wrap">
                                {shoutsCount !== 0 ? <span className="shout-number">{shoutsCount}</span> : null}
                                <img onClick={handleMMBtnClick} className="botimgttlbr titlebar-ico" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAABUUlEQVR4nO3Uz0oDMRDH8bl40r6BHtqLf87qSxYrvoIHERE9tIX6Gtp3EAUPtUeFr8TmILjZlmxmN9H5wLJLYJL9ZbIrYkxZgD3gFnj31x2wLwWGeOM3N7YrpWDViZAbKQWroxSykFIArzVBXqQUwHVNkCspBTAAnitCuLGBlAToA5c/QrjnvpQKT0qHBVEEHAEj4AlYkt7Sz30GHGoE2AIugE/a8wGcu7VThnigO7MkYXwnujZK8U20eZzqjtlBkyDuw87FsEmQOfl4bBJE4xcba9EkSFZEOcgYOAG2/X2iVINmkHGg7j5xjXqQ40DdaeKab6leukovMFcvcU1QqiCtdkQzyCTwUtPENepB8H8ct5s7/j5VqlEP0imxIJkR60hmxDqSGfmzHakSO1ns+DoSK3aB2PF1LAgbso403LCNWUe80MZk25G2yL8PYoxE+wJmA95jdYQihQAAAABJRU5ErkJggg==" />
                            </div> */}
                            <img onClick={handleMMBtnClick} className="botimgttlbr titlebar-ico" src="https://img.icons8.com/glyph-neue/25/FFFFFF/bot.png" />



                            {showModal && <Modal
                                currUser={currUser}
                                handleCloseModal={handleCloseModal}
                                socket={socket}
                                title='Povijest statusa'
                                statusHistory={statusHistory}
                                type='statusHistory'
                                handleKickStatus={handleKickStatus}
                            />}
                            {showMMModal && <Modal
                                currUser={currUser}
                                handleCloseModal={handleCloseMMModal}
                                socket={socket}
                                title=''
                                type='matchmakingQueue'
                                me={me}
                            />}
                            {showMMNewModal && <Modal
                                mmNew={mmNew}
                                currUser={currUser}
                                handleCloseModal={handleCloseMMNewModal}
                                socket={socket}
                                title=''
                                type={'MMNew'}
                                me={me}
                            />}
                            {showPracticeModal && <Modal
                                handleCloseModal={handleClosePracticeModal}
                                socket={socket}
                                title='Vježbaj tipkanje'
                                type={'practice'}
                                questBox={questBox}
                            />}
                            <div className={showModal || showMMModal || showPracticeModal || showMMNewModal ? 'overlay-app' : ''}></div>
                        </div>
                    }

                    <div className="statusbar statusbar-alt2 hidden m780-show">
                        {status.length < 60
                            ?
                            <p className="margin-top-5 margin-bottom-5">{status}</p>
                            :
                            <p className="margin-top-5 text-carousel-titlebar margin-bottom-5">
                                <span
                                    style={{ animation: 'marquee 15s linear infinite' }}>
                                    {status}
                                </span>
                            </p>
                        }
                    </div>

                </div>
            </div>
        )
    }

    return (
        <div>
            {title.length === 0 && generateTitleBar()}
            {title.length !== 0 && (
                <div className="main-header margin-top">
                    <GameBox imgSrc="go-white.png" users={users} socket={socket} gamers={gamers} title={title} sub="Multiplayer završava za:" btnText="empty" />
                </div>
            )}
        </div>
    )
}

export default Titlebar